import { DateTime } from 'luxon';

import { EN_WEEKDAY_KR } from '../DateTimeUtils';

// format y.LL.dd (O) ex. 2020.01.01 (월)
export const formatedDate = (date: DateTime): string => `${date.toFormat('y.LL.dd')} (${EN_WEEKDAY_KR[date.weekday]})`;

export const getDatePickerButtonString = (isRoundTrip: boolean) => (
  startDate: DateTime | null,
  endDate: DateTime | null,
): string => {
  if (!isRoundTrip && startDate) {
    return `${formatedDate(startDate)} ∙ 적용`;
  } else if (!isRoundTrip) {
    return '가는 날 선택';
  }

  if (startDate && !endDate) {
    return `${formatedDate(startDate)} - 오는 날 선택`;
  } else if (startDate && endDate) {
    return `${formatedDate(startDate)} - ${formatedDate(endDate)} ∙ 적용`;
  }

  return '가는 날 - 오는 날 선택';
};

export const getDateString = (startDate: DateTime | null, endDate: DateTime | null): string | null => {
  if (startDate && endDate) {
    return `${formatedDate(startDate)} ~ ${formatedDate(endDate)}`;
  } else if (startDate && !endDate) {
    return `${formatedDate(startDate)}`;
  }

  return null;
};
